<template>
    <div class="infLetter" ref="infLetter">
       
        <information-letter
            v-for="(letter, index) in informationLetters"
            :title="letter.Name"
            :text="letter.Text"
            :key="index"
            :count="index"
            :recommendationId="letter.pivot['RecommendationId']"
        >
        </information-letter>
    </div>
</template>

<script>
import InformationLetter from "./InformationLetter.vue";

    export default {
        name: "InformationLetterList",
        components: {
            InformationLetter,
        },
        props: ["informationLetters"],
        data:function(){
            return {
            };
        },
        methods:{
        }
    };
    </script>